import React, { FunctionComponent } from 'react';
import { Icon } from 'rs-emd-ui-atoms';
import { Math } from 'window-or-global';
import { MediaType } from '../../../../models/pdp/pdp-media-item.model';
import { IPDPMedia, isPDPMediaItem } from '../../../../models/pdp/pdp-media.model';
import styles from './position-indicator-component.module.scss';

type PositionIndicatorProps = {
  data: IPDPMedia;
  selectedMediaIndex: number;
};

export const PositionIndicator: FunctionComponent<PositionIndicatorProps> = (props: PositionIndicatorProps) => {
  return (
    <div className={styles['pi-container']}>
      {props.data.media.map((m, index) => {
        if (isPDPMediaItem(m) && m.mediaType === MediaType.Image)
          return (
            <span
              key={m.id}
              className={`${styles.image} ${
                index === props.selectedMediaIndex
                  ? styles.selected
                  : Math.abs(index - props.selectedMediaIndex) > 1
                  ? styles['no-transition']
                  : ''
              }`}></span>
          );
        else
          return (
            <Icon
              key={isPDPMediaItem(m) ? m.id : m.mpn}
              name={isPDPMediaItem(m) ? (m.mediaType === MediaType.View_3D ? '3d' : 'play') : 'pcb'}
              className={`${styles.icon} ${
                index === props.selectedMediaIndex
                  ? styles.selected
                  : Math.abs(index - props.selectedMediaIndex) > 1
                  ? styles['no-transition']
                  : ''
              }`}
            />
          );
      })}
    </div>
  );
};

export default PositionIndicator;
